import React from "react";

const VimeoEmbed = ({ videoId }) => {
  if (!videoId) return null;

  const embedUrl = `https://player.vimeo.com/video/${videoId}?title=0&byline=0&portrait=0&badge=0&autopause=0`;

  return (
    <div className="vimeo-wrapper mb-2">
      <iframe
        src={embedUrl}
        frameBorder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowFullScreen
        title="Vimeo Video"
      ></iframe>
    </div>
  );
};


export default VimeoEmbed;
